import { omit } from "lodash";

import { createUrl } from "../utils";
import { ApiRoutes } from "../constants/ApiRoutes";
import { HttpMethod } from "../dto/ApplicationDTO";
import { baseApi, CommonApiTypes } from "./baseApi";

export const commonApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadFile: builder.mutation<Application.ResponseProps<Common.FileProps>, FormData>({
      query: (query) => ({
        url: createUrl(ApiRoutes.CommonUploadFile, { query: omit(query, "body") }),
        method: HttpMethod.Post,
        body: query,
      }),
    }),
    augustInfo: builder.query<Application.ResponseProps<August.AugustInfoResponse>, void>({
      query: () => ApiRoutes.AugustInfo,
      providesTags: [CommonApiTypes.AugustInfo],
    }),
    conversionInfo: builder.query<Application.ResponseProps<August.ConversionResponse>, void>({
      query: () => ApiRoutes.ConversionInfo,
    }),
    currencyList: builder.query<
      Application.ResponseProps<Currency.Props[]>,
      Currency.GetCurrenciesFilterProps | void
    >({
      query: (query) => createUrl(ApiRoutes.CurrencyList, { query }),
      providesTags: [CommonApiTypes.CurrenciesList],
    }),
    agreement: builder.query<Application.ResponseProps<Common.AgreementProps>, void>({
      query: (query) => createUrl(ApiRoutes.Agreement, { query }),
      providesTags: [CommonApiTypes.Agreement],
    }),
    userAgreements: builder.query<Application.ResponseProps<Common.UserAgreements>, void>({
      query: () => ApiRoutes.UserAgreemnets,
      providesTags: [CommonApiTypes.Agreement],
    }),
    getRiskAgreement: builder.query<Application.ResponseProps<Common.AgreementProps>, void>({
      query: (query) => createUrl(ApiRoutes.RiskAgreement, { query }),
      providesTags: [CommonApiTypes.RiskAgreement],
    }),
    callback: builder.mutation<Application.ResponseProps, Common.CallbackBodyProps>({
      query: (query) => createUrl(ApiRoutes.Callback, { query }),
    }),
    callbackAvailableTimes: builder.query<
      Application.ResponseProps<string[]>,
      Common.CallbackAvailableTimesBodyProps
    >({
      query: (query) => createUrl(ApiRoutes.CallbackAvailableTimes, { query }),
      providesTags: [CommonApiTypes.CallbackAvailableTimes],
    }),
    getBitrixData: builder.query<Application.ResponseProps<Common.BitrixDataProps>, void>({
      query: () => ApiRoutes.BitrixData,
      providesTags: ["Profile"],
    }),
  }),
});

export const {
  useUploadFileMutation,
  useLazyGetRiskAgreementQuery,
  useCurrencyListQuery,
  useLazyCurrencyListQuery,
  useAgreementQuery,
  useUserAgreementsQuery,
  useCallbackMutation,
  useAugustInfoQuery,
  useLazyCallbackAvailableTimesQuery,
  useConversionInfoQuery,
  useGetBitrixDataQuery,
} = commonApi;

/**
 * Selectors
 */

export const selectCurrenciesResult = commonApi.endpoints.currencyList.select();
